"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
function Portal(_a) {
    var children = _a.children, _b = _a.zIndex, zIndex = _b === void 0 ? 1 : _b, target = _a.target, className = _a.className;
    var _c = react_1.useState(false), mounted = _c[0], setMounted = _c[1];
    var elementRef = react_1.useRef();
    react_1.useLayoutEffect(function () {
        setMounted(true);
        elementRef.current = target || document.createElement('div');
        if (!target) {
            document.body.appendChild(elementRef.current);
        }
        return function () {
            !target && document.body.removeChild(elementRef.current);
        };
    }, [target]);
    if (!mounted) {
        return null;
    }
    return react_dom_1.createPortal(react_1.default.createElement("div", { className: className, style: { position: 'relative', zIndex: zIndex }, "data-mantine-portal": true }, children), elementRef.current);
}
exports.Portal = Portal;
Portal.displayName = '@mantine/core/Portal';
